import { BiLingualValue } from 'types/common'
import { Language } from 'types/language'
import { checkIsStaging } from 'utils/helpers'

export const FullLanguages = {
  [Language.DUTCH]: 'Nederlands',
  [Language.FRENCH]: 'Français'
}

export const PHONE_NOT_REACHABLE = false

export const PLENTY_URL = `${checkIsStaging() ? 'https://staging.' : 'https://'}plenty.be`

export const PORTAL_URL = `${checkIsStaging() ? 'https://staging.' : 'https://'}my.boltenergie.be`

export enum SessionStorageKeys {
  MARKETING = 'MarketingStore',
  FROM = 'fromPage',
  PRODUCT = 'chosenProduct'
}

export const socials = {
  email: 'mailto:info@boltenergie.be',
  facebook: 'https://www.facebook.com/boltenergie/',
  instagram: 'https://www.instagram.com/boltenergie/'
}

export const BOLT_ENERGIE_CARE_PARTNER_ID = '0010900001mIpTBAA0'

export const BOLT_EMAIL: BiLingualValue<string> = {
  [Language.DUTCH]: 'hallo@boltenergie.be',
  [Language.FRENCH]: 'bonjour@boltenergie.be'
}

export const BOLT_PHONE = '02 899 33 00'

export const TAKEOVER_DOCUMENT_URL: BiLingualValue<string> = {
  [Language.DUTCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/energieovernamedocument.pdf',
  [Language.FRENCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/document-de-reprise-des-energies.pdf'
}

export const PLENTY_INFO_NOTE: BiLingualValue<string> = {
  [Language.DUTCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/plenty/informatienota.pdf',
  [Language.FRENCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/plenty/note-d-information.pdf'
}
